import React from "react"
import clsx from "clsx"
import { HighlightState, TextBox } from "@hg/dialog-sdk"
import { motion } from "motion/react"
import { dialogResources } from "../../config"
import { PortraitComponent } from "./Portrait"
import { TextBoxContent } from "./TextBoxContent"
import styles from "./index.module.scss"

export const DialogContent: React.FC<{
    highlight: HighlightState | undefined
    backgroundImage: string
    nameImages: string
    type: "guide" | "normal" | "guideSkill"
}> = ({ highlight, backgroundImage, nameImages, type }) => {
    return (
        <div
            className={clsx(
                styles.dialogContent,
                type === "guide" && styles.guide
            )}
        >
            {/* 左侧角色立绘 */}
            <motion.div
                key="portrait-left"
                className={styles.portraitLeftWrapper}
                initial={{ opacity: 0, x: `-${100 / 16}rem` }}
                animate={{ opacity: 1, x: 0 }}
                transition={{
                    duration: 0.5,
                    ease: [0.25, 0.46, 0.45, 0.94],
                }}
            >
                <PortraitComponent
                    side="left"
                    characterImages={dialogResources.characters}
                    emotionImages={dialogResources.emotions}
                    isHighlighted={highlight === "left"}
                />
            </motion.div>

            {/* 文本框区域 */}
            <motion.div
                key="textbox"
                className={styles.textBoxWrapper}
                style={{
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
                initial={{ opacity: 0, y: `${100 / 16}rem` }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                    duration: 0.5,
                    ease: [0.25, 0.46, 0.45, 0.94],
                }}
            >
                {/* 角色名字 - 左上角 */}
                {nameImages && (
                    <motion.div
                        key={`char-${nameImages}`}
                        className={styles.characterNames}
                        initial={{ opacity: 0, y: `0.6rem` }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                            duration: 0.3,
                            delay: 0.2,
                            ease: [0.25, 0.46, 0.45, 0.94],
                        }}
                    >
                        <img
                            src={nameImages}
                            alt="中文名"
                            className={styles.name}
                        />
                    </motion.div>
                )}

                <TextBox.Root showCursor={true} className={styles.textBox}>
                    <TextBoxContent />
                </TextBox.Root>
            </motion.div>

            {/* 右侧角色立绘 */}
            <motion.div
                key="portrait-right"
                className={styles.portraitRightWrapper}
                initial={{ opacity: 0, x: `${100 / 16}rem` }}
                animate={{ opacity: 1, x: 0 }}
                transition={{
                    duration: 0.5,
                    ease: [0.25, 0.46, 0.45, 0.94],
                }}
            >
                <PortraitComponent
                    side="right"
                    characterImages={dialogResources.characters}
                    emotionImages={dialogResources.emotions}
                    isHighlighted={highlight === "right"}
                />
            </motion.div>
        </div>
    )
}
